// not a plain JSON because `@wix/santa-build` doesn't include `*.json`s to the `dist`
export default {
    STYLESHEET_KEY_PATH: ['style', 'properties', '$st-css'],
    VARIANT_CLASSNAME: 'root',
    COMPONENT_PREFIX: ['wixui.', 'dsgnsys.'],
    STYLE_CHANGE_STACK_LABEL: 'stylable changed',
};
